import { render } from "./MediaLibraryFileTypes.vue?vue&type=template&id=6ad53f42"
import script from "./MediaLibraryFileTypes.vue?vue&type=script&lang=js"
export * from "./MediaLibraryFileTypes.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "6ad53f42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ad53f42', script)) {
    api.reload('6ad53f42', script)
  }
  
  module.hot.accept("./MediaLibraryFileTypes.vue?vue&type=template&id=6ad53f42", () => {
    api.rerender('6ad53f42', render)
  })

}

script.__file = "resources/js/Pages/Media/MediaLibraryFileTypes.vue"

export default script